
import React from "react";
import { motion } from "framer-motion";

const images = [
  "/lovable-uploads/09a7994e-6009-4b4d-a075-777fa17101cb.png",
  "/lovable-uploads/0b469f3d-856f-46dd-bdbd-a72675f5f325.png",
  "/lovable-uploads/7c62dd0b-e539-4203-a60a-6bc7f311869f.png",
  "/lovable-uploads/1f2b1448-a2bd-458c-82f9-a73bb1c5edc8.png",
  "/lovable-uploads/be06cbde-d197-4393-8178-f69093d87d35.png",
];

const ImageSlideshow = () => {
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="relative w-full h-[600px] overflow-hidden">
      {/* Text Overlay with Orange Bar */}
      <div className="absolute inset-0 flex flex-col justify-end pb-16 z-10">
        <div className="w-full flex">
          <div className="w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] text-right p-4 md:p-6 bg-orange-400">
            <div className="ml-auto w-[55%] text-left">
              <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[2.8rem] leading-none font-bold text-white">
                Industry Leading
              </div>
              <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[2.8rem] leading-none font-bold text-white mt-2">
                Safety & Innovation
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Slideshow Images */}
      {images.map((image, index) => (
        <motion.img
          key={index}
          src={image}
          alt={`Slide ${index + 1}`}
          className="absolute w-full h-full object-cover"
          style={{
            zIndex: index === currentImageIndex ? 1 : 0,
            opacity: index === currentImageIndex ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
          }}
          loading="lazy"
          decoding="async"
          fetchpriority={index < 3 ? "high" : "low"}
        />
      ))}
    </div>
  );
};

export default ImageSlideshow;
